import { styled } from '@mui/material';

export const Container = styled('div')<{ replies?: boolean }>`
  display: flex;
  flex-grow: 1;
  gap: ${({ theme }) => theme.spacing(5)};
  padding: ${({ theme, replies }) => theme.spacing(replies ? 2 : 6, 0, 6)};
  width: 100%;
`;
export const FormContainer = styled('div')`
  flex-grow: 1;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('xl')} {
    max-width: ${({ theme }) => theme.spacing(122)};
  }
`;
export const ActionsBar = styled('div')`
  margin-top: ${({ theme }) => theme.spacing(4)};
  display: flex;
  gap: ${({ theme }) => theme.spacing(4)};
`;
